import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!keyword.trim()) return;
    navigate(`/rankings?q=${encodeURIComponent(keyword.trim())}`);
  }

  return (
    <section className="relative flex min-h-[480px] w-full items-center overflow-hidden bg-background-900 md:min-h-[560px]">
      <img
        src="https://readdy.ai/api/search-image?query=vibrant%20stylized%20anime%20cityscape%20illustration%20with%20floating%20books%2C%20comic%20panels%20and%20speech%20bubbles%20in%20the%20sky%2C%20warm%20coral%20orange%20and%20teal%20teal%20color%20palette%2C%20dreamy%20artistic%20manga%20mood%2C%20high%20detail%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=home-hero-2026&orientation=landscape"
        alt="歪歪漫画网 漫画分类与阅读推荐"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-20 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm">
          <i className="ri-fire-line text-secondary-300" />
          分类大全 · 人气排行 · 免费专区 一站直达
        </span>
        <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          歪歪<span className="text-secondary-300">漫画</span>网
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
          恋爱、热血、悬疑、治愈等全题材漫画分类大全，人气排行与热门榜单实时更新。新作推荐、完结作品、免费专区一键切换，快速找到你想看的那部漫画。
        </p>

        <form
          onSubmit={submit}
          className="mx-auto mt-8 flex max-w-xl items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 p-2 backdrop-blur-md"
        >
          <i className="ri-search-line pl-3 text-lg text-background-50/80" />
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索你感兴趣的漫画、标签或作者"
            className="h-10 w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-50/60"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            立即搜索
          </button>
        </form>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {[
            { n: "10+", l: "全题材分类" },
            { n: "3000+", l: "人气作品" },
            { n: "1000+", l: "免费漫画" },
            { n: "日更", l: "榜单实时更新" },
          ].map((s) => (
            <div
              key={s.l}
              className="rounded-xl border border-background-50/20 bg-background-50/10 px-5 py-3 text-left backdrop-blur-sm"
            >
              <p className="font-heading text-2xl text-secondary-300">{s.n}</p>
              <p className="text-xs text-background-50/80">{s.l}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2">
        <Link
          to="/rankings"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/30 text-background-50/80 transition-colors hover:text-secondary-300"
          aria-label="向下滚动查看人气排行"
        >
          <i className="ri-arrow-down-line" />
        </Link>
      </div>
    </section>
  );
}